<template>
    <div class="login">
        <div class="mymain-login">
            <div class="table">
                <div class="imgDiv">
                    <img src="@/assets/images/login1.png" alt="">
                </div>
                <el-form :model="datas" :rules="rules" ref="datas" class="fromdiv">
                    <p>账户登录</p>
                    <div class="fromitem">
                        <el-form-item prop="username">
                            <el-input v-model="datas.username" @keyup.enter.native="clickLogin" placeholder="请输入手机号" clearable>
                                <i slot="prefix" class="iconfont icon-zhanghao"></i>
                            </el-input>
                        </el-form-item>     
                        <!-- 请输入短信验证码 -->
                        <el-form-item prop="password">
                            <el-input v-model="datas.password" @keyup.enter.native="clickLogin" placeholder="请输入短信验证码" class="inputcode" clearable>
                                 <i slot="prefix" class="iconfont icon-yanzhen_icon"></i>
                            </el-input>
                            <input type="button" class="code" v-model="codeMsg" @click="clickCode" :disabled="codeDisabled" />
                        </el-form-item>                         
                        <!-- <el-form-item prop="password">
                            <el-input type="password" v-model="datas.password" @keyup.enter.native="clickLogin" placeholder="请输入密码" autocomplete="off" clearable>
                                <i slot="prefix" class="iconfont icon-mima1"></i>
                            </el-input>
                        </el-form-item> -->
                        <!-- 如果连续登陆失败3次，出现图形验证码 -->
                        <!-- <el-form-item prop="verifycode" v-show="showfailure">
                            <el-input v-model="datas.verifycode" @keyup.enter.native="clickRegistered" placeholder="请输入验证码" class="inputcode" clearable>
                                <i slot="prefix" class="iconfont icon-yanzhen_icon"></i>
                            </el-input>
                            <div class="imgdiv" @click="getCode">
                                <img :src="imgsrc" alt="">
                            </div>
                        </el-form-item>  -->
                        <div class="btndiv">
                            <el-button type="primary" :loading="btnloading" @click="clickLogin('datas')">登 录</el-button>
                            <!-- <div class="divdiv">
                                <span>
                                    <router-link to="/setPassword">忘记密码</router-link>
                                </span>
                                <span>
                                    <router-link to="/registered">
                                        <em>立即注册<i class="el-icon-d-arrow-right"></i></em>
                                    </router-link>
                                </span>
                            </div> -->
                        </div>
                    </div>
                </el-form>                
            </div>
        </div>
    </div>
</template> 

<script>
import api from "@/api/login.js";
import store from "@/vuex/store";
let Base64 = require('js-base64').Base64;
    export default {
        data() {
            // 验证规则
            var validateName = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入手机号'));
                } else {
                    //验证手机号码                   
                    let reg=11 && /^((13|14|15|17|18|19)[0-9]{1}\d{8})$/;
                    if(!reg.test(value)){
                        callback(new Error('手机格式不正确'));    
                    }else{
                        this.showname = true;
                        callback();
                    }
                }
            };
            var validateVerifycode = (rule, value, callback) => {
                if(this.showfailure==true){
                    if (value === '') {
                        callback(new Error('请输入验证码'));
                    } else {  
                        let reg = /^[A-Za-z0-9]{1,6}$/;      //正则匹配：英文大小写，数字
                        if(!reg.test(value)){
                            callback(new Error('请输入正确的验证码'));    
                            return false
                        }                    
                        callback();
                    }
                }else{
                    callback();
                }
            };
            var validatePass = (rule, value, callback) => {
                if (value.replace(/(^\s+)|(\s+$)/g,"") === '') {
                    callback(new Error('请输入密码'));
                } else {
                    callback();
                }
            };
            return {
                datas:{
                    username: '',  // 15094005830
                    password: '',  // 111111  
                    // verifycode: '' 
                    // code: ''       //如果连续登陆失败3次，出现图形验证码                               
                },
                btnloading: false,
                rules: {                  //验证
                    username: [ { required: true, validator: validateName, trigger: 'blur' } ],
                    password: [  { required: true, message: '请输入短信验证码', trigger: 'blur' }],
                    // password: [ { required: true, validator: validatePass, trigger: 'blur' } ],
                    // verifycode: [ { required: true, validator: validateVerifycode, trigger: 'blur' } ],
                }, 
                showfailure: false,       //如果连续登陆失败3次，出现图形验证码
                locanum: 0,
                identifyCode: '',         //验证码
                imgsrc: '',
                showname: false,
                countdown: 60,           // 倒计时秒数
                codeDisabled: false,     // 是否禁用按钮 
                timer: null,              // 定时器 
                codeMsg: '获取验证码',    // 按钮上的文字
            }
        },
        store,
        created(){
            // this.getCode();
            // if(sessionStorage['locanum']>2){
            //     this.showfailure = true;
            // }
        },
        methods:{
            // 验证码
            clickCode(){               
              //获取验证码的请求  
              if(this.showname==false){
                this.$message.error('请输入手机号'); 
                return false
              }
              api.codess(this.datas).then(Response=>{
                    //console.log(Response)
                    this.$message('验证码已发送'); 
                    // 验证码60秒倒计时
                    if(!this.timer) {
                        this.timer = setInterval(() => {
                            if (this.countdown > 0 && this.countdown <= 60) {
                                this.countdown--;
                                if (this.countdown != 0) {
                                    this.codeMsg = this.countdown + "s后再获取";
                                    this.codeDisabled = true;
                                } else {
                                    clearInterval(this.timer);
                                    this.codeMsg = '获取验证码';
                                    this.countdown = 60;
                                    this.timer = null;
                                    this.codeDisabled = false;
                                }
                            }
                        }, 1000)            
                    }                                      
                }).catch(error=>{
                    //console.log(error)
                    this.getCode();
                })
            },
            // 登录
            clickLogin(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {  
                            // if(sessionStorage['locanum'] > 2){       
                            //     this.showfailure = true;
                            // }
                            //登录的接口
                            this.btnloading = true;
                            api.login(this.datas).then(Response=>{
                                localStorage.token = Response.data;  
                                this.$message.success('登录成功');  
                                setTimeout(() => {                    
                                    this.$router.push('/')
                                }, 2000);
                            }).catch(error=>{
                                //console.log(error)
                                this.btnloading = false; 
                                this.locanum+=1;
                                sessionStorage['locanum'] = this.locanum;   
                                // if(sessionStorage['locanum']>2){
                                //     // this.showfailure = true;
                                //     this.getCode();  
                                // }                             
                            })    
                        
                    } else {
                        //console.log('error submit!!');
                        return false;
                    }
                });        
            },
            // 获取验证码
            getCode(){
                this.imgsrc = "https://pay.horti-expo2019.com:8890/ticketAppUser/getVerifyCode?"+Math.random();
            }            
        },
        watch: {
          // 如果路由有变化，会再次执行该方法
          "$route": "routeNew"
        }
        
    }
</script>

<style lang="stylus" scoped>
.login {
  position: absolute;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  .mymain-login {
    width: 100%;
    height: 100%;
    margin: auto;
    background: url(../assets/images/loginbg.png) center no-repeat;
    background-size: cover;
    position: relative;
    .table {
        width: 468px;
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        -o-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -webkit-transform: translate(-50%, -50%);
        .imgDiv{
            width: 468px;
            margin: auto;  
            padding-bottom: 40px; 
            text-align: center;    
            img {
                display: inline-block;
                max-width: 100%;
                max-height: 100%;
            }
        }
        .fromdiv{
            background-color: rgba(255,255,255,0.3);
            border-radius: 6px;
            padding: 14px 0 0 0;
            margin: 0 50px;
            text-align: center;
            p{
                color: #fff;
                letter-spacing: 1px;
            }
            .fromitem{
                padding: 25px 25px 20px 25px;
                .iconfont{
                    font-size: 20px;
                    display: inline-block;
                    color: #38608F;
                }
                .code{
                    float: left;
                    padding: 1px 0;
                    width: 135px;
                    height: 36px;
                    color: inherit;
                    background: #f4f4f5;
                    display: inline-block;
                    border: none;
                    border-left: 0;
                    border-radius: 0 36px 36px 0;
                    cursor: pointer;
                    color: #909399;
                }
                .code:hover{
                    background: #909399;
                    color: #fff;
                }
                .imgdiv{
                    width: 143px;
                    height: 36px;
                    float: left;
                    img{
                        width: 100%;
                        height: 100%;
                        display: inline-block;
                        border-radius: 0 36px 36px 0;
                    }
                }
            }
            .btndiv{ 
                .el-button{
                    width: 100%;
                    background-color: #16365C;
                    border: none;
                    font-size: 16px;
                    margin-top: 9px;
                    border-radius: 40px;
                }             
                .divdiv{
                    font-size: 14px;
                    padding-top: 14px;
                    display: flex;
                    justify-content: space-between;
                    a{
                        color: #16365c;
                    }                    
                }
            }
        }
    }
  }
}


</style>
<style>
.login .el-input__inner,
.login .el-form-item__content {
    height: 36px!important;
    line-height: 36px!important;
    border-radius: 36px!important;  
}
.login .el-input__prefix{
    left: 18px!important;
}
.login .inputcode{
    width: 180px!important;
    float: left;
}
.login .el-input__inner{
    padding-left: 50px!important;
}
.login .inputcode .el-input__inner{
    border-radius: 36px 0 0 36px!important;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue